import { getRoutingIcon } from '@/constants/routingAssets'

import {
  DistanceContainer,
  RoutingText,
  BoldRoutingText
} from '../ParkingTile.styled'

interface RoutingType {
  icon: string
  distance: any
  description: string
}

const RoutingBox: React.FC<RoutingType> = ({ icon, distance, description }) => {
  return (
    <DistanceContainer>
      <img src={getRoutingIcon(icon)} alt={`${icon} icon`} />
      <BoldRoutingText>
        {distance}
        <RoutingText>{description}</RoutingText>
      </BoldRoutingText>
    </DistanceContainer>
  )
}

export default RoutingBox
